import MediaUpload, { MediaInfo } from '@client/new/components/MediaUpload';
import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { CoverImage } from '../viewModel/editOtpBundle.vm';
import { OfferThumbnailTooltip } from './OfferThumbnailTooltip';
import * as styles from './BundleCoverImage.css';

type BundleCoverImageProps = {
  creatorId: number;
  value: CoverImage | null;
  onChange: (value: CoverImage | null) => void;
  disabled?: boolean;
};

export const BundleCoverImage = ({
  creatorId,
  value,
  onChange,
  disabled,
}: BundleCoverImageProps) => (
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-10">
      <Typography variant="body" size="large" fontWeight="medium">
        Thumbnail
      </Typography>
      <OfferThumbnailTooltip>
        <FontAwesomeIcon
          icon={faInfoCircle}
          className={styles.infoIcon}
          tabIndex={0}
          role="button"
          aria-label="Offer thumbnail information"
        />
      </OfferThumbnailTooltip>
    </div>
    <Typography color="N-80" fontWeight="normal" size="medium">
      This will be displayed on Offers Landing page
    </Typography>
    {disabled ? (
      value ? (
        <img
          src={encodeURI((value.cdn01 || '') + (value.image || ''))}
          alt="Bundle cover"
          className="w-[150px] h-[150px] object-cover rounded-[10px]"
          data-testid="bundleCoverImage"
        />
      ) : null
    ) : (
      <MediaUpload
        id="bundle-cover"
        creatorId={creatorId}
        accept={['image/png', 'image/jpeg']}
        className="w-[150px] h-[150px] rounded-[10px] bg-[#F8F8F8]"
        value={value}
        onChange={(metadata) =>
          onChange(
            metadata
              ? { image: metadata.image || '', cdn01: metadata.cdn01 || '' }
              : null,
          )
        }
      >
        <MediaInfo
          title="Upload square image"
          subtitle="Drag & drop or choose"
          textClassName={styles.mediaInfoText}
        />
      </MediaUpload>
    )}
  </div>
);
